var angular = require('angular');

export default angular.module('asError', []).component('asError', {
    template: require('./asError.component.html'),
    styleUrls: require('./asError.component.css'),
    controller: ['$window', asErrorComponent],
    bindToController: true,
    bindings: {
        resolve: '<'
    }
});

function asErrorComponent($window) {
    var vm = this;

    vm.close = function() {
        $window.location.reload();
    };
}



// WEBPACK FOOTER //
// ./modules/shared/asError/asError.component.js